import { render, staticRenderFns } from "./InboxPlugin.vue?vue&type=template&id=45042fa2&scoped=true"
import script from "./InboxPlugin.vue?vue&type=script&lang=js"
export * from "./InboxPlugin.vue?vue&type=script&lang=js"
import style0 from "./InboxPlugin.vue?vue&type=style&index=0&id=45042fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45042fa2",
  null
  
)

export default component.exports